import React, { useCallback } from 'react';
import { useRouter } from 'next/router';
import FeedbackPage from '@pedidosya/web-fenix/system/FeedbackPage';
import FooterButton from '@pedidosya/web-fenix/system/FooterButton';

function Error() {
  const router = useRouter();

  const handleOnReload = useCallback(() => {
    router.reload();
  }, [router]);

  const handleOnClick = useCallback(() => {
    router.back();
  }, [router]);

  return (
    <FeedbackPage
      title="Tuvimos un problema y lo estamos resolviendo"
      description="Lo sentimos. Vuelve a intentar en unos minutos."
      variant="error"
    >
      <FeedbackPage.FooterButton>
        <FooterButton.Button
          fullWidth
          hierarchy="primary"
          label="Reintentar"
          onClick={handleOnReload}
          size="large"
        />
        <FooterButton.Button
          fullWidth
          hierarchy="primary"
          label="Regresar"
          onClick={handleOnClick}
          size="large"
        />
      </FeedbackPage.FooterButton>
    </FeedbackPage>
  );
}

export default Error;
